import type {SvgIconProps} from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import {memo} from 'react';

export const Kafka = memo((props: SvgIconProps) => {
  const {style, ...restProps} = props;

  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{
        width: 'var(--size, 24px)',
        height: 'var(--size, 24px)',
        ...style,
      }}
      {...restProps}
    >
      <path d="m15.54 12.97c-.68 0-1.3.25-1.78.67l-1.29-.75c.09-.29.13-.6.13-.92s-.04-.63-.1-.92l1.23-.73c.48.44 1.12.68 1.81.68 1.49 0 2.7-1.19 2.7-2.68s-1.21-2.69-2.7-2.69-2.7 1.21-2.7 2.7c0 .17.02.37.05.55l-1.25.72c-.43-.45-1-.78-1.64-.95v-1.39c1.09-.35 1.88-1.37 1.88-2.57 0-1.49-1.21-2.69-2.7-2.69s-2.68 1.2-2.68 2.69c0 1.2.76 2.21 1.84 2.57v1.4c-1.48.38-2.58 1.71-2.58 3.31s1.1 2.94 2.58 3.31v1.45c-1.08.36-1.84 1.37-1.84 2.57 0 1.49 1.19 2.7 2.68 2.7s2.7-1.21 2.7-2.7c0-1.2-.79-2.22-1.88-2.57v-1.44c.64-.16 1.2-.49 1.64-.94l1.26.73c-.04.19-.06.38-.06.58 0 1.49 1.21 2.7 2.7 2.7s2.7-1.21 2.7-2.7-1.21-2.69-2.7-2.69m0-5.97c.74 0 1.33.59 1.33 1.32s-.59 1.34-1.33 1.34-1.33-.6-1.33-1.34.59-1.32 1.33-1.32m-7.69-2.31c0-.74.59-1.34 1.33-1.34s1.32.6 1.32 1.34-.58 1.34-1.32 1.34-1.33-.6-1.33-1.34m2.65 14.61c0 .74-.58 1.34-1.32 1.34s-1.33-.6-1.33-1.34.59-1.34 1.33-1.34 1.32.6 1.32 1.34m-1.32-5.41c-1.06 0-1.92-.86-1.92-1.92s.86-1.92 1.92-1.92 1.92.86 1.92 1.92-.86 1.92-1.92 1.92m6.36 3.11c-.74 0-1.33-.6-1.33-1.34s.59-1.33 1.33-1.33 1.33.6 1.33 1.33-.59 1.34-1.33 1.34z" />
    </SvgIcon>
  );
});
Kafka.displayName = 'Kafka';
